import React from 'react';
import { Button } from 'antd';

/**
 * 
 * 错误页 btn
 * 
 */

export const RefreshBtn = () => {
  return (
    <Button
      type="default"
      className='w-192px !h-48px mr-80px'
      onClick={evt => { location.reload() }}
    >
      刷新页面
    </Button>
  );
}

export const BackHomeBtn = () => {
  return (
    <Button
      type="black"
      className='w-192px !h-48px'
      onClick={evt => { location.href = "/" }}
    >
      返回首页
    </Button>
  );
}

export const LoginBtn = () => {
  return (
    <Button
      text="立即登录"
      type="primary"
      icon="loginu"
      iconStyle={{
        width: "19px",
        height: "19px",
        marginRight: "10px",
      }}
      style={{
        display: "inline-flex",
        width: "192px",
        height: "48px",
        fontSize: "14px",
        fontWeight: "600"
      }}
      onClick={evt => {
        
      }}
    />
  );
}
